// import {
//   IgGlobalFilters,
//   insightsiqPlatformWorkIdMap,
//   YtGlobalFilters,
// } from "@entities/globalDiscovery/lib/constants";
import { IgGlobalFilters, insightsiqPlatformWorkIdMap, YtGlobalFilters } from "@entities/global-discovery/constants";
import { CampaignSelector } from "@features/CampaignSelector";
// import DiscoveryNotifications from "@widgets/DiscoveryNotifications/DiscoveryNotifications";
import { useSuggestInfluencerByUsernameBulk } from "@entities/brief/lib/hooks/useSuggestInfluencerUsernameBulk";
import { useGlobalDiscoveryUrlSync } from "@entities/global-discovery/hooks/useGlobalDiscoveryUrlSync";
import { useCampaignStore } from "@entities/global-discovery/store/useCampaignStore";
import { useGetGlobalDiscoveryStore } from "@entities/global-discovery/store/useGetGlobalDiscoveryStoreV2";
import { IModifiedGlobalCreator } from "@shared/lib/types";
import { AdvancedFilters } from "@widgets/GlobalDiscovery/ui/AdvancedFilters";
import { InfluencersTable } from "@widgets/GlobalDiscovery/ui/InfluencersTable/InfluencersTable";
import { SearchHeader } from "@widgets/GlobalDiscovery/ui/SearchHeader";
import { SelectionFooter } from "@widgets/GlobalDiscovery/ui/SelectionFooter";
import { Flex } from "antd";
import { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import styles from "./styles.module.scss";

export function GlobalDiscoverPage() {
  const { isLoadingData, platformId } = useGetGlobalDiscoveryStore();

  const { campaign } = useCampaignStore();

  const { handlePageChange, handleSaveFilters, handlePlatformChange } = useGlobalDiscoveryUrlSync();

  const [showAdvanced, setShowAdvanced] = useState(true);

  const [selectedCreators, setSelectedCreators] = useState<
    IModifiedGlobalCreator[]
  >([]);

  const { suggest, isSuggesting, isSuggested } =
    useSuggestInfluencerByUsernameBulk();

  const [isCampaignError, setIsCampaignError] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

  const campaignSelectorRef = useRef<HTMLDivElement>(null);

  const handleDeselectAll = () => {
    setSelectedCreators([]);
    setSelectedRowKeys([]);
  };

  const onSaveFilters = () => {
    handleSaveFilters();
    handleDeselectAll();
  };

  const handleAddToCampaign = () => {
    // TODO: Implement add to campaign functionality
    suggest({
      data: {
        briefId: campaign?._id || "",
        addBySocialMediaHandle: selectedCreators.map((creator) => ({
          link: creator.url,
          platform: creator?.work_platform?.name?.toLowerCase(),
          username: creator.platform_username,
          followers: creator.follower_count || creator.subscriber_count || 0,
          estViews: 0,
        })),
      },
    });
  };

  const handleHighlightCampaignSelector = () => {
    if (campaignSelectorRef.current) {
      campaignSelectorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      setIsCampaignError(true);

      setTimeout(() => {
        setIsCampaignError(false);
      }, 2000);
    }
  };

  useEffect(() => {
    if (isSuggested) {
      handleDeselectAll();
    }
  }, [isSuggested]);

  // Get filters for current platform
  const platformFilters = useMemo(() => {
    if (!platformId) return [];
    const isInstagram = platformId === insightsiqPlatformWorkIdMap["instagram"];
    const isYoutube = platformId === insightsiqPlatformWorkIdMap["youtube"];

    if (isInstagram) return IgGlobalFilters;
    if (isYoutube) return YtGlobalFilters;
    return [];
  }, [platformId]);

  return (
    <div className={styles.pageContainer}>
      {/* Breadcrumb */}
      <div
        style={{
          marginBottom:
            selectedCreators.length > 0 && selectedRowKeys.length > 0 ? 70 : 0,
        }}
      >
        <Flex justify="space-between" align="start">
          <h1 className={styles.title}>Search & Discover Creators</h1>
          <div
            ref={campaignSelectorRef}
            style={{ width: "250px", marginBottom: "32px" }}
          >
            <CampaignSelector isError={isCampaignError} />
          </div>
        </Flex>
        {/* Search Header */}
        <div className={styles.headerSection}>
          <SearchHeader
            platformId={platformId}
            onToggleAdvanced={() => setShowAdvanced((prev) => !prev)}
            isAdvancedFiltersOpen={showAdvanced}
            handleSaveFilters={onSaveFilters}
            handlePlatformChange={handlePlatformChange}
          />
        </div>

        {/* Filters and Data Side by Side */}
        {platformId && (
          <div className={styles.contentContainer}>
            <div className={styles.dataSection}>
              <InfluencersTable
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
                selectedRows={selectedCreators}
                setSelectedRows={setSelectedCreators}
                isLoading={isLoadingData}
                setCurrentPage={handlePageChange}
                selectedCampaign={campaign}
              />
            </div>
            {platformFilters.length > 0 && (
              <div
                className={`${styles.filtersSidebar} ${
                  showAdvanced ? styles.entering : styles.exiting
                }`}
                style={!showAdvanced ? { visibility: "hidden" } : undefined}
              >
                <AdvancedFilters filters={platformFilters} />
              </div>
            )}
          </div>
        )}
      </div>
      {createPortal(<SelectionFooter
        selectedCreators={selectedCreators}
        onDeselectAll={handleDeselectAll}
        onAddToCampaign={handleAddToCampaign}
        onHighlightCampaignSelector={handleHighlightCampaignSelector}
        isAddingToCampaignLoading={isSuggesting}
      />, document.body)}
      {/* <DiscoveryNotifications /> */}
    </div>
  );
}
